import type { ReactElement } from 'react'

import { IR_MANAGE_ROUTE } from '@/utils/enroutes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'

export const IrManagePage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Management Policy"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <LinkCardList>
        {IR_MANAGE_ROUTE.subdirectories.map(
          ({ path, name, imagePath, ...other }) => (
            <LinkCard
              link={path}
              title={name}
              imgPath={imagePath}
              {...other}
              key={path}
            />
          )
        )}
      </LinkCardList>
    </Layout>
  )
}
IrManagePage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Management Policy', path: '' },
  ]

  return (
    <>
      <Head
        title="Management Policy"
        description="Management Policy"
        ogp={{ url: 'en/ir/manage' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}


